module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/Subject","commonjs2":"rxjs/Subject","amd":"rxjs/Subject"}
// module id = 42
// module chunks = 0 1